import { TENANT_TYPES, USER_ROLES } from '@cyberint/common-utils';

const { ADMIN, INTEL_CONSUMER, INTEL_PRODUCER } = USER_ROLES;

export const isAdminUser = currentUser => currentUser?.role_id === ADMIN;

export const isProducerUser = currentUser => currentUser?.role_id === INTEL_PRODUCER;

export const isConsumerUser = currentUser => currentUser?.role_id === INTEL_CONSUMER;

export const hasFeatureAccess = (features, access_features, allFeaturesAccess) => {
  if (!access_features) {
    return true;
  }

  const accessFeatures = Array.isArray(access_features) ? access_features : [access_features];
  if (allFeaturesAccess) {
    return accessFeatures.every(item => (features || []).some(feature => feature.startsWith(item)));
  }
  return accessFeatures.some(item => (features || []).some(feature => feature.startsWith(item)));
};

export const getIsNonCyberintMsspAdmin = user =>
  user?.customer?.tenant_type === TENANT_TYPES.MSSP_MANAGEMENT && isAdminUser(user);

export const getIsNonCyberintVarAdmin = user =>
  user?.customer?.tenant_type === TENANT_TYPES.PARTNERS_VAR_MANAGEMENT && isAdminUser(user);
